import { render } from "./App.vue?vue&type=template&id=1208bdc5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1208bdc5&lang=css"
script.render = render

export default script